import { Checkbox, VideoThumbnail } from "client/Components";
import { ReactElement, useCallback } from "react";
import { HowToVideoStatus } from "client/Api/Workspace/LiveInformation/HowTos/howToLiveInformation";
import styles from "./HowToListItem.module.less";
import { ListItem } from "../ListItem";
import { localize } from "client_legacy/ndaw/culture";
import { getYoutubeVideoThumbnailUrlFromId } from "client/Misc/youTube";

const {
	Title,
	Description,
	Content,
	ClickableArea,
	RightAddition
} = ListItem;

export type HowToListItemProps = {
	subject: string;
	title: string;
	description: string;
	youtubeId: string;
	status: HowToVideoStatus;
	isCompactView: boolean;
	onStatusChange: (newStatus: HowToVideoStatus) => void;
	onOpenDialog: () => void;
	onClick(): void;
};

export const HowToListItem = (props: HowToListItemProps): ReactElement => {
	const {
		title,
		description,
		youtubeId,
		status,
		isCompactView,
		onStatusChange,
		onOpenDialog,
		onClick
	} = props;

	const changeHandler = (status: boolean) => {
		onStatusChange(status
			? HowToVideoStatus.Watched
			: HowToVideoStatus.Unwatched);
	};

	const clickHandler = useCallback(
		(): void => {
			onOpenDialog();
			onClick();
		},
		[onClick, onOpenDialog]
	);

	return (
		<ListItem
			isHoverable
			isWide={!isCompactView}
			hasSeparateClickableAreas
		>
			<ClickableArea
				onClick={clickHandler}
				shouldGrow
				position="first"
			>
				{!isCompactView && (
					<div className={styles.video}>
						<VideoThumbnail>
							<div
								className={styles.videoBackground}
								style={{
									backgroundImage: `url(${getYoutubeVideoThumbnailUrlFromId(youtubeId)})`,
								}}
							/>
						</VideoThumbnail>
					</div>
				)}
				<Content>
					<Title>{title}</Title>
					{ !isCompactView && (
						<Description>{description}</Description>
					)}
				</Content>
			</ClickableArea>
			<RightAddition>
				<div className={styles.checkbox}>
					<Checkbox
						value={Boolean(status)}
						onChange={changeHandler}
						title={status === HowToVideoStatus.Watched
							? localize("_MarkAsUnwatched")
							: localize("_MarkAsWatched")
						}
					/>
				</div>
			</RightAddition>
		</ListItem>
	);
};
HowToListItem.displayName = "HowToListItem";